import {
    userTypeMenuItems,
    conditionalMenuItems,
} from "@/models/menuItems.js";

export default {
    methods: {
        // Centralizovana metoda za dodavanje kondicionalnih stavki
        addConditionalItems(items) {
            let result = [...items];

            // Dodavanje delivery stavki na osnovu korisničkih svojstava
            if (this.user?.type !== "recipient" && this.user?.is_contract !== 1) {
                result = result.filter(
                    (item) => item.title !== "Испорука" && item.title !== "delivery"
                );

                // Companies delivery logika
                if (this.user?.type === "company" && this.$store.state.company?.contract === 0) {
                    const hasCompaniesDelivery = result.some(
                        (item) => item.title === "companies_delivery"
                    );
                    if (!hasCompaniesDelivery) {
                        result.splice(6, 0, conditionalMenuItems.companies_delivery);
                    }
                } else {
                    result = result.filter((item) => item.title !== "companies_delivery");
                }
            } else if (this.user?.type === 'company' && this.$store.state.company?.contract === 0) {
                const hasCompaniesDelivery = result.some(
                    (item) => item.title === "companies_delivery"
                );
                if (!hasCompaniesDelivery) {
                    result.splice(6, 0, conditionalMenuItems.companies_delivery);
                }
            }

            // Non-contract recipient logika
            if (this.user?.type === "recipient" && this.user?.is_non_contract === 1) {
                const hasGuestDelivery = result.some(
                    (item) => item.title === "Isporuka-za-neregistrovane"
                );
                if (!hasGuestDelivery) {
                    result.splice(5, 0, conditionalMenuItems.guest_delivery);
                }
            } else {
                result = result.filter((item) => item.title !== "Isporuka-za-neregistrovane");
            }

            // Company-specific logika
            if (this.company) {
                // Location stavka
                if (this.company?.parent_id && this.user.type !== 3) {
                    const hasLocation = result.some((item) => item.title === "Локација");
                    if (!hasLocation) {
                        result.push(conditionalMenuItems.location);
                    }
                }

                // Branches vs Users logika
                if ((this.company?.children || []).length > 0 && this.user.type === 'company') {
                    const hasBranches = result.some((item) => item.title === "branches");
                    if (!hasBranches) {
                        result.push(conditionalMenuItems.branches);
                    }
                }

                // result.push(getUsersMenuItem(this.$t.bind(this)));

                // Delivery home logika
                if (this.company.is_delivery === 1) {
                    result = result.map((item) => {
                        if (item.title === "order") {
                            return { ...item, to: { name: "delivery" } };
                        }
                        return item;
                    });
                }
            }

            return result;
        },
    },

    computed: {
        // Centralizovani computed property za dostupne linkove
        availableMenuItems() {
            if (!this.user) return [];

            let baseItems = [...this.computedItems].filter(item => {
                if (item.rule === 'companyCanReport') { return this.user.can_report === 1; };
                return true;
            });
            // Logika za različite tipove korisnika
            switch (this.user.type) {
                case "shop":
                    return userTypeMenuItems.shop;

                case "admin":
                    // Admin specifični linkovi se dodaju u computedItems
                    break;

                case "dostava":
                case "admin_delivery":
                    baseItems.push(...userTypeMenuItems.dostava);
                    break;

                case "supplier":
                    return userTypeMenuItems.supplier;
            }

            // Filtriranje stavki na osnovu korisničkih dozvola i tipova
            let filteredItems = baseItems.filter((item) => {
                // Proverava da li korisnik ima dozvole za rutu
                let route = this.$router.options.routes.find(
                    (route) => route?.name === item.to?.name || route?.path === item.to?.path
                );

                if (!route || !route.roles) {
                    return false;
                }

                if (this.user.type === 'company' && item.title === 'statistics') {
                    return !!this.user.can_report;
                }

                return route.roles.includes(this.user.type);
            });


            // Dodavanje kondicionih stavki
            filteredItems = this.addConditionalItems(filteredItems);
            if (this.user?.type === 'company' && this.user?.can_report === 1) {
                filteredItems.push({
                    title: this.$t("users"),
                    icon: "mdi-file-outline",
                    to: { name: "korisnici" },
                });
                const numberOfRestaurants = (this.user?.companies || []).reduce((total, company) => total + (company.restaurants?.length || 0), 0);
                if (this.user?.type === "company" && numberOfRestaurants > 1) {
                    filteredItems.push(conditionalMenuItems.companyLimits);
                }
            }

            // Uklanjanje duplikata
            return filteredItems.filter(
                (item, index, self) => index === self.findIndex((i) => i.title === item.title)
            );
        },

        menu() {
            const menuItems = this.availableMenuItems.map((item) => {
                // Dinamičko podešavanje ruta na osnovu konteksta
                if (item.title === "order") {
                    if (this.company?.type === "group" && this.user.type === "company") {
                        item.to.name = "category-menu-group";
                    } else {
                        item.to.name = this.company?.type === "group" ? "category-menu" : "company-menu";
                    }
                }

                return item;
            });
            return menuItems;
        },

        customMenu() {
            // Custom user menu
            if (this.user.type === 'report_guest') {
                return [
                    {
                        title: "guest_report",
                        icon: "mdi-file-outline",
                        to: { name: "guest-report" },
                    }
                ];
            }
            if (!this.user?.user_menu?.menu1) return this.computedItems;
            // Superadmin isključuje Finansije/Statistike oznakom "hide_<naslov>" u meniju korisnika;
            // bez oznake front ih i dalje sam dodaje (stariji meniji nemaju ove oznake).
            const storedItems = JSON.parse(this.user.user_menu.menu1) || [];
            const isHideMarker = (item) => typeof item?.title === "string" && item.title.startsWith("hide_");
            const hiddenTitles = storedItems.filter(isHideMarker).map((item) => item.title.slice("hide_".length));
            let items = storedItems.filter((item) => !isHideMarker(item)).map((item) => {
                if (item.title === "customers_restoran") {
                    if (!item.to.params) {
                        item.to.params = { id: "" };
                    }
                    const { restaurants } = this.user;
                    item.to.params.id =
                        this.user && restaurants && restaurants.length ? restaurants[0].id : "";
                }
                return item;
            });
            if (["restaurant", "admin"].includes(this.user?.type)) {
                const guestReportItem = items.find(item => item.title === 'guest_report');
                if (guestReportItem) {
                    if (this.user.type === 'restaurant') {
                        guestReportItem.to = { name: 'guest-report' };
                    } else {
                        items.splice(2, 0, {
                            "title": "guest_report",
                            "icon": "mdi-file-outline",
                            "to": {
                                "name": "guest-report"
                            }
                        })
                    }
                }
            }
            // Settings logika
            if (
                (this.user?.type == "restaurant" && this.restaurant?.pivot?.settings == 1) ||
                this.user?.type == "admin"
            ) {
                const hasSettings = items.some(
                    (item) =>
                        item.title == "Подешавања" ||
                        item.title == "Podesavanja" ||
                        item.title == "settings"
                );
                if (!hasSettings) {
                    items.splice(10, 0, conditionalMenuItems.settings);
                }
                const hasSuppliersLink = items.some((item) => item.title === "suppliers");
                if (!hasSuppliersLink) {
                    items.splice(3, 0, conditionalMenuItems.suppliers);
                }
            }
            items = items.map((item) => {
                if (item.title === "customers_restoran") {
                    return {
                        ...item,
                        title: this.site?.entity_type === "shop" ? "products" : "users",
                    };
                }
                return item;
            });

            // Additional meals for restaurants with komplet_obroci (custom menu)
            if (this.user?.type === "restaurant") {
                const hasAdditionalMeals = (items || []).some((item) => item.title === "additional_meals");
                // if (!hasAdditionalMeals) {
                    // added in menuMixin
                    //items.splice(2, 0, conditionalMenuItems.additional_meals);
                // }
                const hasStatistics = (items || []).some((item) => item.title === "statistics");
                if (!hasStatistics && !hiddenTitles.includes("statistics")) {
                    // added in menuMixin
                    items.splice(2, 0, conditionalMenuItems.statistics);
                }
                const hasFinance = (items || []).some((item) => item.title === "finance");
                if (!hasFinance && !hiddenTitles.includes("finance")) {
                    items.splice(2, 0, conditionalMenuItems.finance);
                }
            }
            if (this.user?.type === "admin") {
                const hasFinance = (items || []).some((item) => item.title === "finance");
                if (!hasFinance) {
                    items.splice(2, 0, conditionalMenuItems.finance);
                }
            }
            // Marketing (promocije) - odmah posle finansija, restoran i admin
            if (this.user?.type === "restaurant" || this.user?.type === "admin") {
                const hasMarketing = (items || []).some((item) => item.title === "marketing");
                if (!hasMarketing) {
                    const financeIndex = items.findIndex((item) => item.title === "finance");
                    items.splice(financeIndex >= 0 ? financeIndex + 1 : 3, 0, conditionalMenuItems.marketing);
                }
            }
            // Knjiženje narudžbi (ručno knjiženje propuštenih) — odmah posle finansija, samo admin
            if (this.user?.type === "admin") {
                const hasLedgerPosting = (items || []).some((item) => item.title === "ledger_posting_title");
                if (!hasLedgerPosting) {
                    const financeIndex = items.findIndex((item) => item.title === "finance");
                    items.splice(financeIndex >= 0 ? financeIndex + 1 : 3, 0, conditionalMenuItems.ledger_posting);
                }
            }
            // Ocene obroka — odmah posle finansija (za sada samo admin)
            if (this.user?.type === "admin") {
                const hasMealRatings = (items || []).some((item) => item.title === "meal_ratings");
                if (!hasMealRatings) {
                    const financeIndex = items.findIndex((item) => item.title === "finance");
                    items.splice(financeIndex >= 0 ? financeIndex + 1 : 2, 0, conditionalMenuItems.meal_ratings);
                }
            }
            // Kategorije namirnica (samo admin): odmah iza Namirnica, i u prilagođenom meniju
            if (this.user?.type === "admin" && !items.some((item) => item.to && item.to.name === "product-categories")) {
                const at = items.findIndex((item) => item.to && item.to.name === "namirnice");
                items.splice(at === -1 ? items.length : at + 1, 0, conditionalMenuItems.product_categories);
            }
            const hasLimits = (items || []).some((item) => item.title === "limits");
            // if (!hasLimits && this.user?.type === "restaurant") {
                // added in menuMixin
                //items.splice(3, 0, conditionalMenuItems.restaurantLimits);
            // }
            const numberOfRestaurants = (this.user?.companies || []).reduce((total, company) => total + (company.restaurants?.length || 0), 0);
            if (!hasLimits && this.user?.type === "company" && numberOfRestaurants > 1) {
                items.splice(3, 0, conditionalMenuItems.companyLimits);
            }
            if (!hasLimits && this.user?.type === "admin") {
                items.splice(3, 0, conditionalMenuItems.companyLimits);
            }

            if (this.user?.type == "admin") {
                // Dodaj post_report na poziciju 3
                const hasPostReport = items.some((item) => item.title === "post_report");
                if (!hasPostReport) {
                    items.splice(3, 0, conditionalMenuItems.post_report);
                }

                const hasContracts = items.some((item) => item.title === "contracts_title");
                if (!hasContracts) {
                    items.splice(4, 0, conditionalMenuItems.contracts);
                }

                // Dodaj users_guest na poziciju 17 (ili na kraj ako je kraći)
                const hasUsersGuest = items.some((item) => item.title === "users_guest");
                if (!hasUsersGuest) {
                    const insertIndex = Math.min(17, items.length);
                    items.splice(insertIndex, 0, conditionalMenuItems.users_guest);
                }
                const hasMessages = items.some((item) => item.title == "messages");
                const hasPosts = items.some((item) => item.title == "delivery_post");

                if (!hasMessages) {
                    items.splice(15, 0, conditionalMenuItems.messages);
                }
                if (!hasPosts) {
                    items.splice(14, 0, conditionalMenuItems.delivery_post);
                }

                const hasOutages = items.some((item) => item.title === "outages");
                if (!hasOutages) {
                    items.splice(15, 0, conditionalMenuItems.outages);
                }
            }
            items = items.filter((item, index, self) => {
                return index === self.findIndex(i => i.to?.name === item.to?.name);
            })
                .filter(item => {
                    return (item.to?.name || item.to?.path) && !['istorija', 'korisnici'].includes(item.to?.name);
                })
                .filter(item => !hiddenTitles.includes(item.title));
            return items;
        },
    },
};
